import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

import { searchAgainCollaterals, destroy } from './actions'

export const createCollateralSearchNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'collateral_search',
  text: translateFn('mnu_coll_edit_view'),
  identity: '/secure/collateral/search',
  permission: 'VIEW_COLLATERAL',
}))

export { searchAgainCollaterals, destroy }

export default Loadable(() => import('./SearchWindow'))
